module.exports = __webpack_public_path__ + "static/proposito-mobile-e732bcb255ea5b5dad123c0bd637422c.jpg";